module.exports = __webpack_public_path__ + "static/media/Icon__DAO--Impact.9d6f7c8c.png";